import FormControlLabel from "@mui/material/FormControlLabel";
import { useTranslation } from "react-i18next";
import { Checkbox } from "src/components/Default/LekUI/Checkbox";

import CountOfQuestionsProgress from "./CountOfQuestionsProgress";
import Filter from "./DefaultFilters";

export default function AdditionalOptionsFilter(props) {
	const { t } = useTranslation();

	const setSelectedType = (additionalOption) => {
		props.setSelectedData({
			additionalOption: {
				...props.selectedData.additionalOption,
				[additionalOption]:
					!props.selectedData.additionalOption[additionalOption],
			},
		});
	};

	const renderFilter = (type, text) => {
		return (
			<FormControlLabel
				label={text}
				control={
					<Checkbox
						className="checkbox"
						checked={props.selectedData.additionalOption[type]}
						onChange={() => setSelectedType(type)}
						data-test-id={`additional-option-${type}`}
					/>
				}
			/>
		);
	};

	const renderShuffleExamOption = () => {
		if (!props.selectedData.shuffle || !props.count) {
			return null;
		}

		return (
			<>
				<FormControlLabel
					label={t("filters.exams.additional.generateRandomExam")}
					control={
						<Checkbox
							className="checkbox"
							checked={props.selectedData.shuffle.checked}
							onChange={() => {
								props.setSelectedData({
									...props.selectedData,
									shuffle: {
										...props.selectedData.shuffle,
										checked: !props.selectedData.shuffle.checked,
									},
								});
							}}
							data-test-id="additional-option-shuffle"
						/>
					}
				/>
				{props.selectedData.shuffle.checked && (
					<CountOfQuestionsProgress
						maxQuestions={props.count}
						value={props.selectedData.shuffle.questions}
						setDetails={(value) => {
							props.setSelectedData({
								...props.selectedData,
								shuffle: {
									...props.selectedData.shuffle,
									questions: value,
								},
							});
						}}
					/>
				)}
			</>
		);
	};

	const renderFilters = () => {
		return (
			<div className="flex flex-col">
				{renderFilter("starred", t("filters.exams.additional.starred"))}
				{renderFilter(
					"wrongAnswers",
					t("filters.exams.additional.wrongAnswers"),
				)}
				{renderFilter(
					"skipCanceledQuestions",
					t("filters.exams.additional.skipCanceledQuestions"),
				)}
				{renderFilter("isNote", t("filters.exams.additional.questionWithNote"))}
				{renderFilter("isUnanswered", t("filters.exams.additional.unanswered"))}
				{renderShuffleExamOption()}
			</div>
		);
	};

	return (
		<Filter
			{...props}
			title={t("filters.exams.additional.title")}
			renderFilterDetails={renderFilters}
		/>
	);
}
